<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">

                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Trụ đèn" :options="category_TRUDEN"
                                :initialValue="modelSearch.trudenChieusangId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'TRUDEN')" />
                        </div>
                        <div class="col mb-3">

                                <TheDateRangePicker title="Ngày báo hỏng" placeholder="Tìm theo ngày báo hỏng"
                                v-model:startDate="modelSearch.ngayBaoHongTungay"
                                v-model:endDate="modelSearch.ngayBaoHongDenngay" :error="''" :isReadOnly="false"
                                :isRequire="false" :key="tempKey"
                                @onChange="(d) => onSelectSearchChange(d, 'NGAYBAOHONG')" />
                        </div>
                        <div class="col mb-3">

                                <TheDateRangePicker title="Ngày tiếp nhận" placeholder="Tìm theo ngày tiếp nhận"
                                v-model:startDate="modelSearch.ngayTiepNhanTungay"
                                v-model:endDate="modelSearch.ngayTiepNhanDenngay" :error="''" :isReadOnly="false"
                                :isRequire="false" :key="tempKey"
                                @onChange="(d) => onSelectSearchChange(d, 'NGAYTIEPNHAN')" />
                        </div>
                        <div class="col mb-3">
                            <TheDateRangePicker title="Ngày khắc phục" placeholder="Tìm theo ngày khắc phục"
                                :isReadOnly="false" :isRequire="false" :key="tempKey" :isTextInput="false"
                                @onChangeDate="(d) => onSelectSearchChange(d, 'NGAYKHACPHUC')" />
                                <TheDateRangePicker title="Ngày khắc phục" placeholder="Tìm theo ngày khắc phục"
                                v-model:startDate="modelSearch.ngay"
                                v-model:endDate="modelSearch.ngayBaoHongDenngay" :error="''" :isReadOnly="false"
                                :isRequire="false" :key="tempKey"
                                @onChange="(d) => onSelectSearchChange(d, 'NGAYKHACPHUC')" />
                        </div>

                    </div>
                </div>


            </div>
        </div>
    </section>

    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="sType_List == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <button v-if="sType_List == typeDataList.DELETED_LIST.id" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapCurrentList')" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == typeDataList.CURRENT_LIST.id" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapDeletedList')" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == typeDataList.DELETED_LIST.id"
                                        class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.RESTORE)" :title="$t('buttons.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('buttons.restore') }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.DELETE_TEMP)"
                                        :title="$t('buttons.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.delete')
                                        }}</a>
                                    <a v-if="sType_List == typeDataList.DELETED_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.DELETE)"
                                        :title="$t('buttons.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.deleteReal')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                    <!-- <a v-if="sType_List == typeDataList.CURRENT_LIST.id"
                                        class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.ON_ENABLED)"
                                        :title="$t('buttons.onEnabled')"><i class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.onEnabled') }}</a>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.OFF_ENABLED)"
                                        :title="$t('buttons.offEnabled')"><i class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.offEnabled') }}</a>
                                    <div class="dropdown-divider"></div> -->
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, navigateCode.CREATE)"
                            v-bind:title="$t('buttons.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col10">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col10 cursor" @click="handleSortChange('suachuaDenChieusangId')">
                                        ID
                                        <span v-if="sortBy == 'suachuaDenChieusangId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col100 cursor" @click="handleSortChange('soTrudenChieusang')">
                                        Số trụ đèn chiếu sáng
                                        <span v-if="sortBy == 'soTrudenChieusang'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('soLuong')">
                                        Số lượng
                                        <span v-if="sortBy == 'soLuong'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('ngayBaoHong')">
                                        Ngày báo hỏng
                                        <span v-if="sortBy == 'ngayBaoHong'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenNguoiBaoHong')">
                                        Người báo hỏng
                                        <span v-if="sortBy == 'tenNguoiBaoHong'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('ngayTiepNhan')">
                                        Ngày tiếp nhận
                                        <span v-if="sortBy == 'ngayTiepNhan'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenNguoiTiepNhan')">
                                        Người tiếp nhận
                                        <span v-if="sortBy == 'tenNguoiTiepNhan'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('ngayKhacPhuc')">
                                        Ngày khắc phục
                                        <span v-if="sortBy == 'ngayKhacPhuc'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <!-- <th class="col50">Hiển thị trên cổng</th> -->
                                    <!-- <th class="col50">Đồng bộ từ IOC tỉnh</th> -->
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td @click="selectRow(item.suachuaDenChieusangId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList_Navigate.csList.includes(item.suachuaDenChieusangId))"
                                            aria-hidden="true" class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td> {{ item.suachuaDenChieusangId }}</td>
                                    <td> {{ item.soTrudenChieusang }}</td>
                                    <td> {{ item.soLuong }}</td>
                                    <td> {{ item.ngayBaoHong }}</td>
                                    <td> {{ item.tenNguoiBaoHong }}</td>
                                    <td> {{ item.ngayTiepNhan }}</td>
                                    <td> {{ item.tenNguoiTiepNhan }}</td>
                                    <td> {{ item.ngayKhacPhuc }}</td>
                                    <!-- <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == typeDataList.DELETED_LIST.id"
                                                :id="'item' + item.suachuaDenChieusangId" v-model="item.enabledDisplay"
                                                v-on:click="openConfirmEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'item' + item.suachuaDenChieusangId"></label>
                                        </div>
                                    </td> -->
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, navigateCode.DETAIL)" :title="$t('labels.detail')">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == typeDataList.CURRENT_LIST.id">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, navigateCode.UPDATE)"
                                                :title="$t('labels.update')">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, sType_List == typeDataList.DELETED_LIST.id ? navigateCode.DELETE : navigateCode.DELETE_TEMP)"
                                            :title="$t('labels.delete')">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;

                                        <button v-if="sType_List == typeDataList.DELETED_LIST.id" type="button"
                                            size="sm" class="btn btn-outline-warning btn-xs"
                                            v-on:click="detail(item, navigateCode.RESTORE)"
                                            :title="$t('labels.restore')">
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-primary">{{ title }}</h4>
                    <button type="button" class="close" aria-label="Close" @click="hideModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col mb-3">
                            <TheSelect title="Trụ đèn" :options="category_TRUDEN"
                                :initialValue="model.trudenChieusangId" :error="errors.trudenChieusangId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.trudenChieusangId = e }" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Số lượng" placeholder="Nhập số lượng" :initialValue="model.soLuong"
                                v-model="model.soLuong" :error="errors.soLuong" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheDatePicker title="Ngày báo hỏng" placeholder="Chọn ngày báo hỏng"
                                :initialValue="model.ngayBaoHong" v-model="model.ngayBaoHong"
                                :error="errors.ngayBaoHong" :isReadOnly="isReadOnly" :isRequire="true" :key="tempKey"
                                @onChangeDate="(d) => { model.ngayBaoHong = d }" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col mb-3">
                            <TheSelect title="Người báo hỏng" :options="category_USER"
                                :initialValue="model.nguoiBaoHong" :error="errors.nguoiBaoHong" :isMultiple="false"
                                :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.nguoiBaoHong = e }" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheDatePicker title="Ngày tiếp nhận" placeholder="Chọn ngày tiếp nhận"
                                :initialValue="model.ngayTiepNhan" v-model="model.ngayTiepNhan"
                                :error="errors.ngayTiepNhan" :isReadOnly="isReadOnly" :isRequire="true" :key="tempKey"
                                @onChangeDate="(d) => { model.ngayTiepNhan = d }" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col mb-3">
                            <TheSelect title="Người tiếp nhận" :options="category_USER"
                                :initialValue="model.nguoiTiepNhan" :error="errors.nguoiTiepNhan" :isMultiple="false"
                                :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { model.nguoiTiepNhan = e }" :key="tempKey" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <TheDatePicker title="Ngày khắc phục" placeholder="Chọn ngày khắc phục"
                                :initialValue="model.ngayKhacPhuc" v-model="model.ngayKhacPhuc"
                                :error="errors.ngayKhacPhuc" :isReadOnly="isReadOnly" :isRequire="true" :key="tempKey"
                                @onChangeDate="(d) => { model.ngayKhacPhuc = d }" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Mô tả" placeholder="Nhập mô tả" :initialValue="model.moTa"
                                v-model="model.moTa" :error="errors.moTa" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="true" :key="tempKey" />
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Ghi chú" placeholder="Nhập ghi chú" :initialValue="model.ghiChu"
                                v-model="model.ghiChu" :error="errors.ghiChu" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="true" :key="tempKey" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left" @click="hideModal()">&nbsp;{{
                        $t('buttons.close') }} </button>

                    <button type="button" class="pull-right" :class="styleButton" @click="onSubmit();">&nbsp;{{ title
                        }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-success">{{ $t('labels.itemDetails') }} </h4>
                    <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="modelRec">
                        <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                            <p class="text-sm">ID:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.suachuaDenChieusangId }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Số trụ đèn:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soTrudenChieusang }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Số lượng:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soLuong }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Ngày báo hỏng:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ngayBaoHong }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Người báo hỏng:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenNguoiBaoHong }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Ngày tiếp nhận:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ngayTiepNhan }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Người tiếp nhận:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenNguoiTiepNhan }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Người khắc phục:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ngayKhacPhuc }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Mô tả:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.moTa }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Ghi chú:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
        <TheConfirmDialog :title="csList_MapModel.title" :confirmLabelButton="csList_MapModel.confirmLabelButton"
            :onClose="csList_MapModel.onClose" :onSubmit="csList_MapModel.onSubmit"
            :modalContent=csList_MapModel.modalContent></TheConfirmDialog>
    </div>

    <!-- <div class="modal fade" id="enabledConfirmModal" data-keyboard="false" data-backdrop="static">
        <TheCheckboxConfirmDialog :title="csListEnabled_MapModel.title"
            :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton" :onClose="csListEnabled_MapModel.onClose"
            :onSubmit="csListEnabled_MapModel.onSubmit" :modalContent=csListEnabled_MapModel.modalContent
            v-model="checkEnable_Memo" :key="tempKey" :submitArgs="csListEnabled_MapModel.submitArgs">
        </TheCheckboxConfirmDialog>
    </div> -->
</template>
<script>

import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import objectDefaultValue from '@/config/object.env'
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import { read, utils, writeFileXLSX } from 'xlsx';
import TheInputText from '@/components/shareComponents/TheInputText.vue'
import TheSelect from '@/components/shareComponents/TheSelect.vue'
import TheConfirmDialog from '@/components/shareComponents/TheConfirmDialog.vue'
import TheCheckboxConfirmDialog from '@/components/shareComponents/TheCheckboxConfirmDialog.vue'
import TheDateRangePicker from '@/components/shareComponents/TheDateRangePicker.vue'
import TheDatePicker from '@/components/shareComponents/TheDatePicker.vue'

import { tableInteractiveModel } from '@/models/general/tableInteractive.model'
import { suachuaDenChieusangModel } from '@/models/hethongchieusang/suachuaDenChieusang.model'

export default {
    name: "SuaChuaDenChieuSang",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,

        TheConfirmDialog,
        TheCheckboxConfirmDialog,
        TheDateRangePicker,
        TheDatePicker
    },

    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            modelRec: suachuaDenChieusangModel.newModel(),
            model: suachuaDenChieusangModel.newFEModel(),
            errors: suachuaDenChieusangModel.errors(),
            modelSearch: suachuaDenChieusangModel.newPagingSearchModel(),

            cEnable_Value: null,

            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,

            csList: [],
            csList_Code: null,
            checkEnable_Memo: false,
            sType_List: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),
            category_TRUDEN: [],
            category_USER: [],

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,

            tempKey: common.randomString(10),
        }
    },

    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        ...mapActions('handleData2', ['handleChangeType',]),
        ...mapActions('suachuaDenChieusang', ['getPagingSuachuaDenChieusang', 'getDetailSuachuaDenChieusang', 'checkExistSuachuaDenChieusang', 'createSuachuaDenChieusang', 'updateSuachuaDenChieusang', 'deleteSuachuaDenChieusang', 'restoreSuachuaDenChieusang', 'handleListSuachuaDenChieusang', 'setEnabledSuachuaDenChieusang']),
        ...mapActions('trudenChieusang', ['getBasicTrudenChieusang']),
        ...mapActions('nguoiDung', ['getBasicNguoiDung']),

        async setup() {
            let header = 'Danh sách sữa chữa đèn chiều sáng'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_TRUDEN = await this.getCategory_TruDenChieuSang()
            this.category_USER = await this.getList_NguoiDung()
        },

        //#region NavigateModal
        async showModal() {
            $('#insUpdModal').modal('show')
        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
            // await this.getData()
        },
        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },
        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
        },

        // async showEnabledConfirmModal() {
        //     this.csListEnabled_MapModel = {
        //         title: "XÁC NHẬN",
        //         confirmLabelButton: "Xác nhận",
        //         onClose: this.closeConfirmEnabledChange,
        //         onSubmit: this.updateEnabled,
        //         submitArgs: [2],
        //         modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
        //     }
        //     this.tempKey = common.randomString(10)
        //     $('#enabledConfirmModal').modal('show')
        // },
        // async hideEnabledConfirmModal() {
        //     $('#enabledConfirmModal').modal('hide')
        // },
        //#endregion NavigateModal

        //#region NavigateInTable
        async openConfirmEnabledChange(item) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Value = item
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Value = item
                this.updateEnabled(1)

            }
        },

        // async updateEnabled(from) {
        //     let model = {
        //         suachuaDenChieusangId: this.cEnable_Value.suachuaDenChieusangId,
        //         enabled: from == 1 ? !this.cEnable_Value.enabledDisplay : this.cEnable_Value.enabledDisplay
        //     }
        //     await this.setEnabledSuachuaDenChieusang({ model: model }).then(resp => {
        //         if (resp) {
        //             this.hideEnabledConfirmModal()
        //         }
        //         else {
        //             this.hideEnabledConfirmModal()
        //         }
        //     });
        // },

        // async closeConfirmEnabledChange() {
        //     this.cEnable_Value.enabledDisplay = !this.cEnable_Value.enabledDisplay
        //     $('#item' + this.cEnable_Value.suachuaDenChieusangId).prop('checked', this.cEnable_Value.enabledDisplay);
        //     await this.hideEnabledConfirmModal()
        // },

        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },

        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.suachuaDenChieusangId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        //#endregion NavigateInTable

        //#region NavigateSearch
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == this.typeDataList.DELETED_LIST.id) this.sType_List = this.typeDataList.CURRENT_LIST.id
            else if (this.sType_List == this.typeDataList.CURRENT_LIST.id) this.sType_List = this.typeDataList.DELETED_LIST.id
            await this.handlePageChange(1)
        },
        async onSelectSearchChange(e, typeChange) {
            // if (typeChange == 'ENABLED') {
            //     switch (e) {
            //         case "true":
            //             this.modelSearch.enabled = true
            //             break
            //         case "false":
            //             this.modelSearch.enabled = false
            //             break
            //         default:
            //             this.modelSearch.enabled = null
            //     }
            //     this.handlePageChange(1)
            //     return
            // }
            if (typeChange == 'TRUDEN') {
                this.modelSearch.trudenChieusangId = e == "" ? null : e
                await this.handlePageChange(1)
                return
            }

            if (typeChange === 'NGAYBAOHONG') {
                await this.handlePageChange(1);
            }

            if (typeChange === 'NGAYTIEPNHAN') {
                await this.handlePageChange(1);
            }

            if (typeChange === 'NGAYKHACPHUC') {
                await this.handlePageChange(1);
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            // if (this.modelSearch.tenTruong == "") this.modelSearch.tenTruong = null
            // if (this.modelSearch.truongId == "") this.modelSearch.truongId = null
            // if (this.modelSearch.vemisId == "") this.modelSearch.vemisId = null
        },

        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()

            await this.getPagingSuachuaDenChieusang({ params: this.modelSearch, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        // this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        //#endregion NavigateSearch

        //#region CUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = suachuaDenChieusangModel.errors()

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    suachuaDenChieusangId: item.suachuaDenChieusangId
                }
                let resp = await this.getDetailSuachuaDenChieusang({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = suachuaDenChieusangModel.newModel()
                        this.modelRec = resp
                        this.model = suachuaDenChieusangModel.parseModeltoFEModel(this.modelRec)
                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    suachuaDenChieusangId: item.suachuaDenChieusangId
                }
                await this.getDetailSuachuaDenChieusang({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = suachuaDenChieusangModel.newModel()
                        this.modelRec = resp
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else {

                this.model = suachuaDenChieusangModel.newFEModel()
                this.filesUpload = []
                //this.triggerDetail()
                this.isReadOnly = (code == this.navigateCode.CREATE) ? false : true
                //this.isReadOnly = this.isReadOnly = (code == "delete") ? true : false
                // show popup
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },

        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistSuachuaDenChieusang({ params: params })
            return res.data

        },
        async validate(model) {
            let isvalid = true
            this.errors = suachuaDenChieusangModel.errors()
            if (!await this.validateRequired(model.soLuong)) {
                this.errors.soLuong = "Nhập số lượng"
                isvalid = false
            }
            else if (!await this.validateNumber(model.soLuong)) {
                this.errors.soLuong = "Số lượng phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateRequired(model.nguoiBaoHong)) {
                this.errors.nguoiBaoHong = "Chọn người báo hỏng"
                isvalid = false
            }

            if (!await this.validateRequired(model.trudenChieusangId)) {
                this.errors.trudenChieusangId = "Chọn trụ đèn"
                isvalid = false
            }
            if (!await this.validateRequired(model.ngayBaoHong)) {
                this.errors.ngayBaoHong = "Chọn ngày báo hỏng"
                isvalid = false
            }
            if (!await this.validateRequired(model.ngayTiepNhan)) {
                this.errors.ngayTiepNhan = "Chọn ngày tiếp nhận"
                isvalid = false
            }
            if (!await this.validateRequired(model.ngayKhacPhuc)) {
                this.errors.ngayKhacPhuc = "Chọn ngày khắc phục"
                isvalid = false
            }




            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = suachuaDenChieusangModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.suachuaDenChieusangId = FEmodel.suachuaDenChieusangId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.suachuaDenChieusangId = FEmodel.suachuaDenChieusangId
                sendModel.trudenChieusangId = FEmodel.trudenChieusangId
                sendModel.soLuong = FEmodel.soLuong
                sendModel.ngayBaoHong = FEmodel.ngayBaoHong
                sendModel.nguoiBaoHong = FEmodel.nguoiBaoHong
                sendModel.ngayTiepNhan = FEmodel.ngayTiepNhan
                sendModel.nguoiTiepNhan = FEmodel.nguoiTiepNhan
                sendModel.ngayKhacPhuc = FEmodel.ngayKhacPhuc
                sendModel.moTa = FEmodel.moTa
                sendModel.ghiChu = FEmodel.ghiChu
            }
            console.log(sendModel)
            return sendModel
        },
        async onSubmit() {
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createSuachuaDenChieusang({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateSuachuaDenChieusang({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteSuachuaDenChieusang({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteSuachuaDenChieusang({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreSuachuaDenChieusang({ model: sendModel })
                    break
                default:
            }
            if (res) {
                await this.getData()
                this.hideModal()
            }
        },
        //#endregion CUD

        //#region NavigateMultipleInTable
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                this.csList_MapModel = {
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: this.hidePopupconfirmcsListModal,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.showPopupconfirmcsListModal()
            }
        },
        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            // if (code == this.navigateCode.OFF_ENABLED) {
            //     modelSend.model.enabled = false
            // }
            // if (code == this.navigateCode.ON_ENABLED) {
            //     modelSend.model.enabled = true
            // }
            // if (code == this.navigateCode.ON_IOC_ENABLED) {
            //     modelSend.model.enabled = false
            // }
            // if (code == this.navigateCode.OFF_IOC_ENABLED) {
            //     modelSend.model.enabled = true
            // }
            let res = null
            res = await this.handleListSuachuaDenChieusang(modelSend)
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.hidePopupconfirmcsListModal()
            }
        },
        //#endregion NavigateMultipleInTable


        //#region getCategory
        async getCategory_TruDenChieuSang() {
            let params = {
                chieuSang: true
            }
            let res = await this.getBasicTrudenChieusang({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].trudenChieusangId,
                            name: res[i].soTru
                        }
                    )
                }

                return handleRes
            }
            return []
        },

        async getList_NguoiDung() {
            let params = {
            }
            let res = await this.getBasicNguoiDung({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].userId,
                            name: res[i].hoTen
                        }
                    )
                }

                return handleRes
            }
            return []
        },
        //#endregion getCategory
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style></style>